import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import UnderConstruction from './pages/UnderConstruction';
import VerifyIdCard from './pages/VerifyIdCard';
import VerifyTransferCertificate from './pages/VerifyTransferCertificate';
import VerifyStudentFee from './pages/VerifyStudentFee';
import './App.css';

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'instant'
    });
  }, [pathname]);

  return null;
};

function App() {
  return (
    <Router>
      <ScrollToTop />
      <div className="App flex flex-col min-h-screen">
        <div className="sticky top-0 z-50 flex flex-col">
          <Header />
        </div>
        <main className="flex-grow">
          <Routes>
            <Route path="/" element={<UnderConstruction />} />
            <Route path="/academics" element={<UnderConstruction />} />
            <Route path="/admissions" element={<UnderConstruction />} />
            <Route path="/school-at-a-glance" element={<UnderConstruction />} />
            <Route path="/activities" element={<UnderConstruction />} />
            <Route path="/verify/idCard/:uniqueId" element={<VerifyIdCard />} />
            <Route path="/verify/idCard" element={<VerifyIdCard />} />
            <Route path="/verify/transferCertificate/:uniqueId" element={<VerifyTransferCertificate />} />
            <Route path="/verify/transferCertificate" element={<VerifyTransferCertificate />} />
            <Route path="/verify/studentFee/:uniqueId" element={<VerifyStudentFee />} />
            <Route path="/verify/studentFee" element={<VerifyStudentFee />} />
            <Route path="*" element={<UnderConstruction />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
